import React from 'react';
import type { BapAd } from '../../../types';

type BapSearchExtrasProps = {
    ad: BapAd;
    className?: string;
};

export function BapSearchExtras(props: BapSearchExtrasProps) {
    const { ad, className = '' } = props;

    const clothingSize = ad.extras
        ?.filter(({ id }) => id === 'clothing_size')
        .map(({ values }) => values[0])
        .shift();

    const hasExtras = Boolean(clothingSize);

    if (!hasExtras) {
        return null;
    }

    return (
        <div className={`${className} text-xs`}>
            {clothingSize && <span>{clothingSize}</span>}
        </div>
    );
}
